module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAMAAADyHTlpAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTLK8yr/H07O9y7G6ya+6yLnCz6+5yLC4yLG6ycDI0LfAzrK1zbG7yr/H1L/H06+5yL/H0247eNgAAAAQdFJOUwA7v3ul54zBIGUf/RBQ1a9297xhAAAA9klEQVQ4y9WU2w6EIAxEuRRKRVf4/59dYDWIFuXRnRdiODbDtKkQL5RzbgSbNZqQhCAf6kGoMnRDkgmN7NwjdTgL3SiZWLbuEjhZDjUsGpggiCcDDhdlysqS5BbovVtdnusSZZyAWwf5lsqBZ99nFPto24bJmlH0E30X9Qqmw/NjQTWH+hijuqCGyhhAM2Axq5Zd0levAwWtbdBPKDVoj/UtarN1YEkjM1qbu+YfZ3ZgFqEaVJVHOobVP3dw6ECJ7spmj3MTrNqMOzj53G8/hxHYzcgKI9V8FL81FgsIQIfht+v0xmV5FUvC6B7obgJ2aSEnEv+oL2U7KbSnciGfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/zzsy.png
// module id = ljHv
// module chunks = 0